import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';

import { toast } from "react-toastify";
import { Col, Form, Row, Spinner } from "react-bootstrap";

import { getConnectionCredentials, saveConnectionCredentials, updateConnectionCredentials } from "../../../../../../services/manager-settings.service";
import Error from "../../../../../../components/Error";

import logoDeduca from "../../../../../../../assets/img/logo-deduca.svg";

import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { ConcludeBtn, TokenBtn } from "../../../styles";
import { SupportContactManager } from "../../../../support-contact-manager";
import { ICommonComponent } from "../../models/commonComponent";

interface IIntegrationDeduca extends ICommonComponent { 
  setShowFormIntegration: any
}

const validationSchema = Yup.object({
  client_id: Yup.string().trim().required("Este campo é obrigatório").matches(/^(\S+$)/, 'Este campo não pode conter espaços'),
  client_secret: Yup.string().trim().required("Este campo é obrigatório").matches(/^(\S+$)/, 'Este campo não pode conter espaços'),
  url_instance: Yup.string().required("Este campo é obrigatório").matches(/^(\S+$)/, 'Este campo não pode conter espaços').url('Este campo deve conter uma URL válida'),
  description: Yup.string().matches(/^(?!\s+$).*/, 'Este campo não pode conter apenas espaços'),

}).required();


export const IntegrationDeduca: React.FC<IIntegrationDeduca> = ({ setShowFormIntegration, isLoading = true}) => {
  const { t: translation } = useTranslation();
  
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });
  
  const [loading, setLoading] = useState(true);
  const [showRequestToken, setShowRequestToken] = useState(false);
  const [clientId, setClientId] = useState("")
  const [clientSecret, setClientSecret] = useState("")
  const [description, setDescription] = useState("")
  const [url, setUrl] = useState("")
  const [id, setId] = useState("")

  useEffect(() => {
    setLoading(true)
    getConnectionCredentials().then((res) => {
      setId(res.id)
      setClientId(res.client_id)
      setClientSecret(res.client_secret)
      setUrl(res.url_instance)
      setDescription(res.description)
      setLoading(false)
    }).catch((e) => {            
      setLoading(false)
    })
  }, [])

  const onSubmit = (params: any) => {
    setLoading(true)
    if (id) {
        updateConnectionCredentials(id, params).then((response: any) => {
          toast.success("Credencial salva com sucesso!");
          setLoading(false)
        }).catch((err) => {
          toast.error('Ocorreu um erro ao salvar suas credenciais');
          setLoading(false)
        })
    } else {
      saveConnectionCredentials(params).then((response: any) => {
        toast.success("Credencial salva com sucesso!");
        setLoading(false)
      }).catch((err) => {
        toast.error('Ocorreu um erro ao salvar suas credenciais');
        setLoading(false)
      })
    }
  };

  if (loading && isLoading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  if (showRequestToken) {
    return (
      <>
        <div className="bg-disciplines text-white p-3">
          <HiOutlineArrowCircleLeft className="cursor-pointer mr-3 mb-1" size="25" 
            onClick={() => {
              setShowRequestToken(false);
              setShowFormIntegration(true);
            }}
          /> 
          <span style={{ fontSize: '20px' }}><b>{translation('contactForm.title')}</b></span>
        </div>
        <div className="px-4 mt-3">
          <SupportContactManager/>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="bg-disciplines text-white p-3">
          <HiOutlineArrowCircleLeft className="cursor-pointer mr-3" size="25" onClick={() => setShowFormIntegration(false)}/> 
          <img src={logoDeduca} height={45} alt=""/>
      </div>
      <div className="px-4 mt-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group className="mb-2">
                <Form.Label className="text-darker-grey"> Client ID </Form.Label>
                <Form.Control
                  defaultValue={clientId}
                  type="text"
                  {...register("client_id", { required: true })}
                />
                {errors.client_id ? (
                  <div className="w-100">
                    {" "}
                    <Error>{errors.client_id?.message}</Error>{" "}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label className="text-darker-grey">
                  {" "}
                  Client Secret{" "}
                </Form.Label>
                <Form.Control
                  defaultValue={clientSecret}
                  type="text"
                  {...register("client_secret", { required: true })}
                />
                {errors.client_secret ? (
                  <div className="w-100">
                    {" "}
                    <Error>{errors.client_secret?.message}</Error>{" "}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-2">
                <Form.Label className="text-darker-grey"> URL</Form.Label>
                <Form.Control
                  defaultValue={url}
                  type="text"
                  {...register("url_instance", { required: true })}
                />
                {errors.url_instance ? (
                  <div className="w-100">
                    {" "}
                    <Error>{errors.url_instance?.message}</Error>{" "}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="text-darker-grey">
                  {" "}
                  {translation("manager.settings.desc")}{" "}
                </Form.Label>
                <Form.Control
                  defaultValue={description}
                  type="text"
                  {...register("description", { required: true })}
                />
                {errors.description ? (
                  <div className="w-100">
                    {" "}
                    <Error>{errors.description?.message}</Error>{" "}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>

            <div className="mb-4 mt-4">
              <ConcludeBtn className="mr-2" type="submit">
                <span className="mr-2 ml-2">{translation("save")}</span>
              </ConcludeBtn>
              <TokenBtn
                type="button"
                data-testid="tokenbtn"
                onClick={() => setShowRequestToken(true)}
              >
                {translation("manager.settings.request")}
              </TokenBtn>

              {loading ? (
                <Spinner
                  animation="border"
                  variant="primary"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    borderWidth: "0.25em",
                    borderRightColor: "transparent",
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          </Row>
        </Form>
      </div>
    </>
  );
};
